import { cn } from "@/utils/cn";
import { IonSkeletonText } from "@ionic/react";
import { memo } from "react";

interface RenderImageStateProps {
  src: string;
  alt: string;
  status: "loading" | "error" | "loaded";
  notFoundImage?: React.ReactNode;
  errorImage?: React.ReactNode;
  classNames?: {
    image?: string;
  };
  setStatus: (status: "loading" | "error" | "loaded") => void;
}

export const RenderImageState = memo(function RenderImageState({
  src,
  alt,
  status,
  notFoundImage,
  errorImage,
  classNames,
  setStatus,
}: RenderImageStateProps) {
  if (src === "") {
    return (
      <div className={cn(`flex h-full w-full items-center justify-center`, classNames?.image)}>
        {notFoundImage}
      </div>
    );
  }
  if (status === "loading") {
    return (
      <>
        <img
          src={src}
          alt={alt}
          onLoad={() => setStatus("loaded")}
          onError={() => setStatus("error")}
          loading="lazy"
          className={cn(
            `h-full w-full object-cover transition-opacity duration-500`,
            classNames?.image,
          )}
        />
        <IonSkeletonText className="bg-image-loading absolute inset-0 z-10 h-full w-full" />
      </>
    );
  }

  if (status === "error") {
    if (errorImage) {
      return (
        <div className={cn(`flex h-full w-full items-center justify-center`, classNames?.image)}>
          {errorImage}
        </div>
      );
    }
    return null;
  }

  return (
    <img
      src={src}
      alt={alt}
      onLoad={() => setStatus("loaded")}
      onError={() => {
        console.log("image error", src, alt);
        setStatus("error");
      }}
      loading="lazy"
      className={cn(
        `h-full w-full object-cover transition-opacity duration-500`,
        classNames?.image,
      )}
    />
  );
});
